;(function () {

"use strict";

var VerticalTabsView = Backbone.View.extend({
  initialize: function () {
    // console.log('init vertical tabs view');
    this.$tabs = this.$el.children('ul').children();
  },
  toggle: function (e) {
    var $this = $(e.currentTarget).parent();

    if (!$this.hasClass('active')) {
      this.$el.find('li').removeClass('active');
    }

    $this.toggleClass('active');
  },
  events: {
    'click h6': 'toggle'
  }
});

module.exports = VerticalTabsView;

}());